// Redux
import { AnyAction } from 'redux';
import { AsyncAppThunk, AsyncDispatch } from 'src/store/ThunkTypes';

// Data layer
import { setRequestStatus } from 'data-layer-cr/dist/network';
import { NetworkResponse } from 'data-layer-cr/dist/network/NetworkTypes';

// Network
import processRequest from 'src/services/processRequest';

// Actions
import {
  REQUEST_QUOTATIONS_MEASUREMENTS,
  REQUEST_SALES_TREND,
} from '../requestIdentifiers';

import {
  updateQuotationsMeasurements,
  updateSalesTrend,
} from '../slice/metricSlice';

// Models
import QuotationsMeasurements from '../../../models/Chart/QuotationsMeasurements';
import SalesTrend from '../../../models/Chart/SalesTrend';

/**
 * Fetch statistics data, open and close quotations and
 * amount of quotaions by status type
 *
 * @param queryFilter - If provided, a filter will be applied to the response
 */
const requestQuotationsMeasurements =
  (queryFilter: string): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(REQUEST_QUOTATIONS_MEASUREMENTS, 'requesting'));
    try {
      const quotationsMeasurementsResponse = await processRequest<
        NetworkResponse<QuotationsMeasurements[]>
      >({
        method: 'GET',
        url: `Quotation/measurements${queryFilter}`,
        uniqueIdentifier: REQUEST_QUOTATIONS_MEASUREMENTS,
      });
      dispatch(
        updateQuotationsMeasurements(quotationsMeasurementsResponse.data),
      );
      return dispatch(
        setRequestStatus(REQUEST_QUOTATIONS_MEASUREMENTS, 'success'),
      );
    } catch (e) {
      return dispatch(
        setRequestStatus(REQUEST_QUOTATIONS_MEASUREMENTS, 'failure'),
      );
    }
  };

const requestSalesTrend =
  (queryFilter: string): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(REQUEST_SALES_TREND, 'requesting'));
    try {
      const salesTrendReponse = await processRequest<
        NetworkResponse<SalesTrend[]>
      >({
        method: 'GET',
        url: `Quotation/totalsales${queryFilter}`,
        uniqueIdentifier: REQUEST_SALES_TREND,
      });
      dispatch(updateSalesTrend(salesTrendReponse.data));
      return dispatch(setRequestStatus(REQUEST_SALES_TREND, 'success'));
    } catch (e) {
      return dispatch(setRequestStatus(REQUEST_SALES_TREND, 'failure'));
    }
  };

export { requestQuotationsMeasurements, requestSalesTrend };
